import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import consumerFinancingQueryKeys from "../consumerFinancingQueryKeys";

const postAbandonConsumerFinancing = async () => {
  return api.rawPost("api/purchases/c2c-financing/abandon-consumer-financing");
};

export default function useAbandonConsumerFinancingMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postAbandonConsumerFinancing,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: consumerFinancingQueryKeys.consumerFinancing(),
      });
    },
  });
}
